import { SettingsSAMLForm } from "metabase/admin/settings/auth/components/SettingsSAMLForm";
import MetabaseSettings from "metabase/lib/settings";
import {
  PLUGIN_AUTH_PROVIDERS,
  PLUGIN_IS_PASSWORD_USER,
} from "metabase/plugins";

PLUGIN_AUTH_PROVIDERS.SettingsSAMLForm = SettingsSAMLForm;

PLUGIN_AUTH_PROVIDERS.providers.push((providers) => {
  const samlProvider = {
    name: "saml",
    // circular dependencies
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    Button: require("metabase/auth/components/SamlButton").SamlButton,
  };

  return MetabaseSettings.get("saml-enabled")
    ? [samlProvider, ...providers]
    : providers;
});

PLUGIN_IS_PASSWORD_USER.push((user) => user.sso_source !== "saml");
